import TreeNode from './TreeNode';
import Estimate from './Estimate';
import { CriteriaSubject } from './project/SuccessCriteria';

class Scenario {
  public scenario: TreeNode[];
  public probability: number;
  public estimates : Estimate[];

  constructor(
    scenario: TreeNode[],
    probability: number,
    estimates: Estimate[]
  ) {
    this.scenario = scenario;
    this.probability = probability;
    this.estimates = estimates;
  }

  public formatAsString() {
    return this.scenario.reduce((acc, event, index) => {
      const order = index + 1;
      return acc + '#' + order + ' ' + event.title + ' ';
    }, '');
  }

  public getEstimate(estimateType: CriteriaSubject) {
    return this.estimates.find((e) => { return e.estimateType === estimateType; });
  }

  // how we should treat non-existing time estimate?
  public getTimeEstimate() {
    const estimate = this.getEstimate(CriteriaSubject.TIME_ESTIMATE);

    return (estimate) ? estimate.amount : 0;
  }

  public getCustomEstimate() {
    const estimate = this.getEstimate(CriteriaSubject.CUSTOM_ESTIMATE);

    return (estimate) ? estimate.amount : 0;
  }
}

export default Scenario;



// WEBPACK FOOTER //
// ./src/models/Scenario.ts